import { ROLE_IDS, type RoleId } from '@onuw/roles-data'
import type { GuideSlug } from './guideSlugs'

/** A role's address under /roles/: its id in kebab case, "app" spelled out (apprentice-seer). */
export const roleSlug = (id: RoleId): string =>
  id.replace(/^app(?=[A-Z])/, 'apprentice').replace(/[A-Z]/g, (c) => `-${c.toLowerCase()}`)

const BY_SLUG = new Map<string, RoleId>(ROLE_IDS.map((id) => [roleSlug(id), id]))
export const roleOfSlug = (slug: string | undefined): RoleId | undefined =>
  slug ? BY_SLUG.get(slug) : undefined

// Links between the public pages end with a slash: the address Pages serves a prerendered page at (without it,
// every link costs a redirect).
export const rolePath = (id: RoleId) => `/roles/${roleSlug(id)}/`
export const guidePath = (slug: GuideSlug) => `/guides/${slug}/`
